import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tab', 'panel'];
  static values = { locale: { type: String, default: 'de' } };

  connect() {
    this.showLocale(this.localeValue);
  }

  select(event) {
    event.preventDefault();
    const locale = event.params.locale;
    if (!locale) return;

    this.localeValue = locale;
    this.showLocale(locale);
  }

  showLocale(locale) {
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.locale === locale;
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.classList.toggle('is-active', active);
    });

    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.locale !== locale;
    });
  }
}
